<template>
  <div :class="isLoading && $style.isLoading">
    <ProgressCircular
      v-if="isLoading"
      :indeterminate="true"
    />

    <template v-else>
      <UiHeading
        :title="student.fullName"
        green
        :subtitle="'Кабинет курсанта, договор №'+ student.contractNumber "
        :indent="true"
        tag="h1"
      />
      <div :class="$style.wrapper">
        <LessonsInfo
          :instructor="instructor"
          :lessons="lessons"
        />
      </div>
    </template>
  </div>
</template>

<script>
import UiHeading from '@/components/UiHeading';
import ProgressCircular from '@/components/ProgressCircular';
import LessonsInfo from '@/components/PageStudentAccount/LessonsInfo';
/**
 * @TODO: реализовать прелоадер обертку (взять с lk/place)
 */

export default {
  name: 'StudentCard',
  components: {
    UiHeading,
    ProgressCircular,
    LessonsInfo,
  },
  props: {
    student: {
      type: Object,
      default: null,
    },
    instructor: {
      type: Object,
      default: null,
    },
    instructorIsShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isLoading() {
      return !this.student;
    },
    lessons() {
      return this.student?.lessons ?? {};
    },
  },
};
</script>

<style lang="scss" module>
.wrapper {
  display: flex;
  gap: 20px;
  margin-top: 60px;
}

.isLoading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.contract {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
}

.contractTitle {
  margin-right: 10px;
  @include typography(13px, 15px);
}

.contractNumber {
  @include gradientBrand;
  padding: 5px 10px;
  @include typography(13px, 15px);
  font-weight: 700;
  color: $colorWhite;
}

.info {
  margin-bottom: 30px;
}
</style>
